import type { Dict } from "@/types/dict"
import type { FormFieldReference } from "./field"
import type { EventProducer } from "@/utils/event"

export enum EFormEvent {
  FIELD_VALUE_CHANGE = 'FIELD_VALUE_CHANGE',
  FIELD_FOCUS = 'FIELD_FOCUS',
  FIELD_BLUR = 'FIELD_BLUR',
  FIELD_TOUCHED = 'FIELD_TOUCHED',
  FIELD_UNTOUCHED = 'FIELD_UNTOUCHED',
}

export type FormEventMap<State extends Dict, ComputedData extends Dict = Dict> = {
  [EFormEvent.FIELD_VALUE_CHANGE]: {
    field: FormFieldReference<State, any, ComputedData>
  },
  [EFormEvent.FIELD_FOCUS]: {
    field: FormFieldReference<State, any, ComputedData>
  },
  [EFormEvent.FIELD_BLUR]: {
    field: FormFieldReference<State, any, ComputedData>
  },
  [EFormEvent.FIELD_TOUCHED]: {
    field: FormFieldReference<State, any, ComputedData>
  },
  [EFormEvent.FIELD_UNTOUCHED]: {
    field: FormFieldReference<State, any, ComputedData>
  },
}

export type FormEvent<State extends Dict, ComputedData extends Dict = Dict> = FormEventMap<State, ComputedData>[(keyof FormEventMap<State, ComputedData>)];

export type FormEventProducer<State extends Dict, ComputedData extends Dict = Dict> = EventProducer<FormEventMap<State, ComputedData>>;
